'use es6';

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { connect } from 'react-redux';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterDropdownFilter, { RouterFilterTags, ClearFiltersLink, StyledTagsContainer } from './RouterDropdownFilter';
import { RouterSelectSingle } from '../../features/filters';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import LanguageFilterAlert from '../../components/LanguageFilterAlert/LanguageFilterAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const taggedFilters = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE];
const TracksTopFiltersContainer = ({
  hideContentType,
  isRequesting
}) => {
  return !isRequesting && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFilterBar, {
      middleSlot: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.AWARD_TYPE
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.LEVEL
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.DURATION
        }), !hideContentType && /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.CONTENT_TYPE
        }), /*#__PURE__*/_jsx(RouterSelectSingle, {
          filterType: FILTER_TYPES.LANGUAGE,
          menuStyle: {
            maxHeight: '270px'
          },
          menuWidth: "auto",
          retainSelection: false,
          valueRenderer: () => /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.language.filterTitle"
          })
        })]
      }),
      style: {
        margin: '12px 0'
      }
    }), /*#__PURE__*/_jsxs(StyledTagsContainer, {
      children: [taggedFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter)), /*#__PURE__*/_jsx(ClearFiltersLink, {
        filtersToClear: taggedFilters
      })]
    }), /*#__PURE__*/_jsx(LanguageFilterAlert, {})]
  });
};
TracksTopFiltersContainer.propTypes = {
  hideContentType: PropTypes.bool,
  isRequesting: PropTypes.bool
};
function mapStateToProps(state) {
  return {
    isRequesting: state.filters.get('isRequesting')
  };
}
export default connect(mapStateToProps)(TracksTopFiltersContainer);